import $ from 'jquery';
import stores from "../../stores";


$(()=>{
  loadJsStoreDataFromDom();

  function loadJsStoreDataFromDom(){
    $(".js-store-data").each(function(){
      const dataElement = $(this);
      loadJsStoreDataFromElement(dataElement);
    });
  }

  function loadJsStoreDataFromElement(el){
    const storeName = el.data('js-store-name');
    const jsStoreData = el.data('js-store-data');
    const store = stores[storeName];
    if(store){
      store.normalizeAndStoreData(jsStoreData);
    }
    else{
      console.log(`The store that was specified with name ${storeName} is not an actual js store!`);
    }
  }
})


// WEBPACK FOOTER //
// ./src/utilities/loadJsStoreData/index.js